
import { combineReducers } from 'redux';

import multiScene from './multiscene';

export default combineReducers({
    multiScene
});
